import { getUserInfo } from '../services/users.service'

const { createContext, useState, useEffect } = require('react')

export const UserContext = createContext()

export const UserContextProvider = ({ children }) => {
  const [user, setUser] = useState(null)

  useEffect(() => {
    const fetch = async () => {
      const data = await getUserInfo()
      setUser(data)
    }
    fetch()
  }, [])

  return (
    <UserContext.Provider value={{ user }}>{children}</UserContext.Provider>
  )
}
